import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { LangContext, content } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import MarqueeBand from "@/components/landing/Marquee";
import Features from "@/components/landing/Features";
import Products from "@/components/landing/Products";
import Formats from "@/components/landing/Formats";
import Ranges from "@/components/landing/Ranges";
import Applications from "@/components/landing/Applications";
import About from "@/components/landing/About";
import Stats from "@/components/landing/Stats";
import Process from "@/components/landing/Process";
import Faq from "@/components/landing/Faq";
import Quote from "@/components/landing/Quote";
import Footer from "@/components/landing/Footer";

export default function App() {
  const [lang, setLang] = useState("fr");
  const t = content[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <div className="min-h-screen bg-[#0A0B0E] text-white antialiased overflow-x-clip">
        <Nav />
        <main>
          <Hero />
          <MarqueeBand />
          <Features />
          <Products />
          <Formats />
          <Ranges />
          <Applications />
          <About />
          <Stats />
          <Process />
          <Faq />
          <Quote />
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </LangContext.Provider>
  );
}
